<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
import RouteView from '../../../../../manage/src/layouts/RouteView.vue';
export default {
  components: { RouteView },
  name: 'OnlineIndex',
  data() {
    return {
      cur: 0,
      tablist: [
        {
          name: '法援申请',
          path: '/Aid/ApplicationGuide',
        },
        {
          name: '历史援助',
          path: '/Aid/HistoryAid',
        },
      ],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        title: '', //标题
        name: '', //姓名
        sex: undefined, //性别
        phone: '', //手机号
        certificateType: '', //证件类型
        nativePlace: undefined, //籍贯
        workSpace: undefined, //工作单位
        submitObject: false, //提交对象
        basicInfo: [], //申请事项基本情况
        material: '', //相关材料
        fileList: [],
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          {
            min: 3,
            max: 5,
            message: 'Length should be 3 to 5',
            trigger: 'blur',
          },
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          {
            min: 3,
            max: 5,
            message: 'Length should be 3 to 5',
            trigger: 'blur',
          },
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        certificateType: [
          { required: true, message: '请选择证件类型', trigger: 'change' },
        ],
        basicInfo: [
          { required: true, message: '请输入基本形象', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    gotoOnline() {
      if (this.$route.path !== '/OnlineConsultation/HistoryCult') {
        this.$router.push('/OnlineConsultation/HistoryCult');
      }
    },
    gotoHistory: function () {
      if (this.$route.path !== '') {
        this.$router.push('/OnlineConsultation/OnlineCult');
      }
    },
    tabClick(item, index) {
      if (this.$route.path !== item.path) {
        this.$router.push(item.path);
        this.cur = index;
      }
    },
  },
};
</script>
<style scoped>
</style>
